import React from "react";
import {isFuture, parseISO} from "date-fns";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {dateTimeFormat, formatDate, pluralize, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {OfferPriceType} from "../../offer/types/OfferPriceType";
import {IRangeQuery} from "../../request/IRangeQuery";
import {VendorType} from "../../vendor/helpers/VendorType";
import {IParkingPlace} from "../interfaces/IParkingPlace";

interface IProps {
    showDescriptionPrice: boolean;
    renderParkingPlaces: string[];
    property: {
        configuration: {
            show_price_m2: boolean;
        };
        floor: number;
        height_range: {
            lower: number;
            upper: number;
        };
        number: string;
        offer: {
            buildings: number;
            construction_date_range: IRangeQuery<string>;
            floors_above_ground_range: IRangeQuery<number> | null;
            floors_below_ground: number;
            investor: string | null;
            name: string;
            price_type: number | null;
            properties: number;
            parking_places: IParkingPlace[];
            vendor: {
                slug: string;
                name: string;
                type: VendorType;
            };
        };
        price: number | null;
        price_m2: number;
    };
}

export const PropertyDetailGeneratedDescriptionCommercial: React.FunctionComponent<IProps> = (props) => {
    const {property, renderParkingPlaces} = props;
    const {offer} = property;
    const rangesFloorsAbove = offer.floors_above_ground_range && offer.floors_above_ground_range.upper;
    const upper = formatDate(offer.construction_date_range.upper, dateTimeFormat.quarter);
    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const offerInvestorOrVendor = offer.vendor.type === VendorType.DEVELOPER ? offer.investor || offer.vendor.name : "deweloper";

    const parkingPlaces = !isEmpty(offer.parking_places) ? (
        <Text variant="body_copy_1" mb={2}>
            {`Dla przyszłych właścicieli ${offerInvestorOrVendor} przewidział: ${renderParkingPlaces.join(", ")}.`}
        </Text>
    ) : (
        <Text variant="body_copy_1" mb={2}>
            {`Dla przyszłych właścicieli ${offerInvestorOrVendor} nie przewidział miejsc postojowych.`}
        </Text>
    );

    return (
        <>
            <Text variant="body_copy_1" mb={2}>
                {`Cała inwestycja składa się z ${offer.buildings} ${pluralize(["budynku", "budynków", "budynków"])(
                    offer.buildings
                )}, ${pluralize(["w którym", "w których", "w których"])(offer.buildings)} łącznie ${pluralize(["znajduje", "znajdują", "znajdują"])(
                    offer.properties
                )} się ${offer.properties} ${pluralize(["nowy lokal użytkowy", "nowy lokale użytkowe", "nowych lokali użytkowych"])(offer.properties)}.`}
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {`${pluralize(["Budynek posiada", "Budynki posiadają", "Budynki posiadają"])(offer.buildings)} ${
                    rangesFloorsAbove
                        ? `${
                              offer.floors_above_ground_range?.lower === rangesFloorsAbove
                                  ? `${rangesFloorsAbove} ${pluralize(["kondygnacja naziemna", "kondygnacje naziemne", "kondygnacji naziemnych"])(
                                        rangesFloorsAbove
                                    )}`
                                  : `od ${offer.floors_above_ground_range?.lower} do ${offer.floors_above_ground_range?.upper} kondygnacji naziemnych`
                          }`
                        : ""
                }  ${
                    offer.floors_below_ground
                        ? `oraz ${offer.floors_below_ground} ${pluralize(["kondygnację podziemną", "kondygnacje podziemne", "kondygnacji podziemnych"])(
                              offer.floors_below_ground
                          )}`
                        : "oraz nie posiada kondygnacji podziemnych"
                }.`}
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {futureEndDate || !upper
                    ? `Inwestycja ${offer.name} jest ${futureStartDate ? "w trakcie przygotowań" : "w trakcie budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {`Lokal użytkowy o oznaczeniu ${property.number} znajduje się na ${
                    Number.isInteger(property.floor) && (property.floor !== 0 ? `${property.floor} piętrze` : "parterze")
                } budynku, a wysokość pomieszczeń wynosi ${
                    property.height_range.lower === property.height_range.upper
                        ? property.height_range.lower
                        : `od ${property.height_range.lower} do ${property.height_range.upper}`
                } cm.`}
            </Text>

            {parkingPlaces}

            {props.showDescriptionPrice ? (
                <Text variant="body_copy_1" mb={2}>
                    {`Cena ofertowa ${
                        props.property.offer.price_type === OfferPriceType.NETTO
                            ? "netto"
                            : props.property.offer.price_type === OfferPriceType.BRUTTO
                              ? "brutto"
                              : ""
                    } lokalu użytkowego wynosi ${priceFormat(property.price as number)} ${
                        property.price_m2 && property.configuration.show_price_m2 ? ` (${priceM2Format(property.price_m2)})` : ""
                    }.`}
                </Text>
            ) : null}
        </>
    );
};
import React from "react";
import {isFuture, parseISO} from "date-fns";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {dateTimeFormat, formatDate, pluralize, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {OfferPriceType} from "../../offer/types/OfferPriceType";
import {IRangeQuery} from "../../request/IRangeQuery";
import {VendorType} from "../../vendor/helpers/VendorType";
import {IParkingPlace} from "../interfaces/IParkingPlace";

interface IProps {
    showDescriptionPrice: boolean;
    renderParkingPlaces: string[];
    property: {
        configuration: {
            show_price_m2: boolean;
        };
        floor: number;
        height_range: {
            lower: number;
            upper: number;
        };
        number: string;
        offer: {
            buildings: number;
            construction_date_range: IRangeQuery<string>;
            floors_above_ground_range: IRangeQuery<number> | null;
            floors_below_ground: number;
            investor: string | null;
            name: string;
            price_type: number | null;
            properties: number;
            parking_places: IParkingPlace[];
            vendor: {
                slug: string;
                name: string;
                type: VendorType;
            };
        };
        price: number | null;
        price_m2: number;
    };
}

export const PropertyDetailGeneratedDescriptionCommercial: React.FunctionComponent<IProps> = (props) => {
    const {property, renderParkingPlaces} = props;
    const {offer} = property;
    const rangesFloorsAbove = offer.floors_above_ground_range && offer.floors_above_ground_range.upper;
    const upper = formatDate(offer.construction_date_range.upper, dateTimeFormat.quarter);
    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const offerInvestorOrVendor = offer.vendor.type === VendorType.DEVELOPER ? offer.investor || offer.vendor.name : "deweloper";

    const parkingPlaces = !isEmpty(offer.parking_places) ? (
        <Text variant="body_copy_1" mb={2}>
            {`Dla przyszłych właścicieli ${offerInvestorOrVendor} przewidział: ${renderParkingPlaces.join(", ")}.`}
        </Text>
    ) : (
        <Text variant="body_copy_1" mb={2}>
            {`Dla przyszłych właścicieli ${offerInvestorOrVendor} nie przewidział miejsc postojowych.`}
        </Text>
    );

    return (
        <>
            <Text variant="body_copy_1" mb={2}>
                {`Cała inwestycja składa się z ${offer.buildings} ${pluralize(["budynku", "budynków", "budynków"])(
                    offer.buildings
                )}, ${pluralize(["w którym", "w których", "w których"])(offer.buildings)} łącznie ${pluralize(["znajduje", "znajdują", "znajdują"])(
                    offer.properties
                )} się ${offer.properties} ${pluralize(["nowy lokal użytkowy", "nowy lokale użytkowe", "nowych lokali użytkowych"])(offer.properties)}.`}
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {`${pluralize(["Budynek posiada", "Budynki posiadają", "Budynki posiadają"])(offer.buildings)} ${
                    rangesFloorsAbove
                        ? `${
                              offer.floors_above_ground_range?.lower === rangesFloorsAbove
                                  ? `${rangesFloorsAbove} ${pluralize(["kondygnacja naziemna", "kondygnacje naziemne", "kondygnacji naziemnych"])(
                                        rangesFloorsAbove
                                    )}`
                                  : `od ${offer.floors_above_ground_range?.lower} do ${offer.floors_above_ground_range?.upper} kondygnacji naziemnych`
                          }`
                        : ""
                }  ${
                    offer.floors_below_ground
                        ? `oraz ${offer.floors_below_ground} ${pluralize(["kondygnację podziemną", "kondygnacje podziemne", "kondygnacji podziemnych"])(
                              offer.floors_below_ground
                          )}`
                        : "oraz nie posiada kondygnacji podziemnych"
                }.`}
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {futureEndDate || !upper
                    ? `Inwestycja ${offer.name} jest ${futureStartDate ? "w trakcie przygotowań" : "w trakcie budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </Text>

            <Text variant="body_copy_1" mb={2}>
                {`Lokal użytkowy o oznaczeniu ${property.number} znajduje się na ${
                    Number.isInteger(property.floor) && (property.floor !== 0 ? `${property.floor} piętrze` : "parterze")
                } budynku, a wysokość pomieszczeń wynosi ${
                    property.height_range.lower === property.height_range.upper
                        ? property.height_range.lower
                        : `od ${property.height_range.lower} do ${property.height_range.upper}`
                } cm.`}
            </Text>

            {parkingPlaces}

            {props.showDescriptionPrice ? (
                <Text variant="body_copy_1" mb={2}>
                    {`Cena ofertowa ${
                        props.property.offer.price_type === OfferPriceType.NETTO
                            ? "netto"
                            : props.property.offer.price_type === OfferPriceType.BRUTTO
                              ? "brutto"
                              : ""
                    } lokalu użytkowego wynosi ${priceFormat(property.price as number)} ${
                        property.price_m2 && property.configuration.show_price_m2 ? ` (${priceM2Format(property.price_m2)})` : ""
                    }.`}
                </Text>
            ) : null}
        </>
    );
};
